export const theme = {
  // re-defining base colors for use with dots or so, so we can use slightly different shades of base color across the app.
  green: 'green',
  red: 'red',
  orange: 'orange',
  lightGreen: 'lime',

  primary: {
    background: '#ffffff',
  },
  secondary: {
    background: '#f6f7f8',
  },

  valid: {
    background: '#00ff0042',
  },

  invalid: {
    background: '#ff000042',
  }
};
